import React from 'react';
import { Loader2 } from 'lucide-react';
import './Button.css';

/**
 * Button Component
 * @param {string} variant - 'primary', 'secondary', 'ghost', 'danger'
 * @param {string} size - 'sm', 'md', 'lg'
 * @param {boolean} isLoading - Show loading spinner
 * @param {React.ReactNode} icon - Icon component to display
 * @param {string} iconPosition - 'left' or 'right'
 */
const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    className = '',
    isLoading = false,
    disabled = false,
    icon = null,
    iconPosition = 'left',
    type = 'button',
    onClick,
    ...props
}) => {
    const baseClass = 'ui-btn';
    const variantClass = `ui-btn-${variant}`;
    const sizeClass = `ui-btn-${size}`;
    const loadingClass = isLoading ? 'ui-btn-loading' : '';

    return (
        <button
            type={type}
            className={`${baseClass} ${variantClass} ${sizeClass} ${loadingClass} ${className}`}
            disabled={disabled || isLoading}
            onClick={onClick}
            {...props}
        >
            {isLoading && <Loader2 className="ui-btn-spinner" size={18} />}

            {!isLoading && icon && iconPosition === 'left' && (
                <span className="ui-btn-icon-left">{icon}</span>
            )}

            <span className="ui-btn-content">{children}</span>

            {!isLoading && icon && iconPosition === 'right' && (
                <span className="ui-btn-icon-right">{icon}</span>
            )}
        </button>
    );
};

export default Button;
